Vue.filter("thousands", function(number)
{
    return number.toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

});
